import {Injectable, OnDestroy} from '@angular/core';
import {NotificationService} from '~core/components/notification/notification.service';
import {NotificationType} from '../enum/notification.enum';
import {Notification} from '../models/reusables/notification';

/**
 * Service the default notification that we will overwrite in order to keep the duration
 */
@Injectable({
  providedIn: 'root'
})
export class DefaultNotificationService implements OnDestroy {
  public defaultNotification: Notification = {
    type: NotificationType.SUCCESS,
    message: 'Notification',
    duration: 5000
  };

  constructor(private notificationService: NotificationService) {
  }

  public ngOnDestroy(): void {
  }

  /**
   * Overwrites the existing default notification and pushes it to the notification service
   */
  public showNotification(notification: Notification): any {
    const overwrittenNotification: Notification = {...this.defaultNotification, ...notification};
    this.notificationService.showNotification(overwrittenNotification);
  }

}
